import React, { Component } from 'react';
import { Thumbnail, Col, Button, Row, Well, Affix, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'

import NavHeader from './navheader'
import { setPaymentStage } from '../actions'
import { getMoneyFormat } from '../utils'
import _ from 'lodash'

class OrderReviewFooter extends Component {

    state = {
        showModal: false
    }

    getTotalPrice() {
        let total_price = 0
        _.map(this.props.products, product => {
            total_price += product.product_price_unit * product.product_amount
        })
        return total_price.toFixed(2)
    }

    getTotalAmount() {
        let total_amount = 0
        _.map(this.props.products, product => {
            total_amount += 1
        })
        return Math.round(total_amount)
    }

    getTotalExtraproductAmount() {
        let total_amount = 0
        _.map(this.props.extraproducts, product => {
            total_amount += 1
        })
        return Math.round(total_amount)
    }

    getTotalUnit() {
        let total_unit = 0
        _.map(this.props.products, product => {
            total_unit += Number(product.product_amount)
        })
        return Number(total_unit.toFixed(2))
    }

    getTotalExtraproductUnit() {
        let total_unit = 0
        _.map(this.props.extraproducts, product => {
            total_unit += Number(product.product_amount)
        })
        return Number(total_unit.toFixed(2))
    }

    getTotalReserve() {
        let total_reserve = 0
        _.map(this.props.products, product => {
            total_reserve += product.product_price_unit * product.product_amount * (product.product_reserve_factor)
        })
        return total_reserve.toFixed(2)
    }

    onSubmit() {
        if (this.props.delivery_time != '') {
            this.props.setPaymentStage('confirm_address')
            this.props.history.push('/confirm_address')
        } else {
            // this.setState({ showModal: true })
            // this.props.setShowAlert(true)
            window.alert('กรุณาเลือกช่วงเวลาจัดส่ง - รับสินค้า')
        }
    }

    render() {
        return (
            <div>
                <Well className="footer">
                    <Row>
                        <Button onClick={() => { this.onSubmit() }} className='pull-right' style={{ width: 170, height: 40, marginTop: 12 }} bsStyle='success'>ดำเนินการต่อ</Button>
                        <div className='pull-right' style={{ marginRight: 10 }}><h5 style={{ textAlign: 'right', display: 'inline-block' }}>รวมค่าสินค้า ({this.getTotalAmount() + this.getTotalExtraproductAmount()} รายการ): </h5> <h4 style={{ display: 'inline-block' }}><strong style={{ color: 'red' }}>{getMoneyFormat(this.getTotalPrice())}</strong></h4> <h5 style={{ display: 'inline-block' }}>บาท</h5></div>
                    </Row>
                </Well>
                {/* Modal */}
                <Modal show={this.state.showModal} onHide={() => { this.setState({ showModal: false }) }} >
                    <Modal.Header>
                        <Modal.Title><div style={{ textAlign: 'center' }}>กรุณาเลือกช่วงเวลาจัดส่ง - รับสินค้า</div></Modal.Title>
                        <Modal.Body><div style={{ textAlign: 'center' }}>ช่วงเวลาจัดส่งหมายถึงช่วงเวลาที่พนักงานเริ่มทำการจัดส่ง</div></Modal.Body>
                        <Modal.Footer><button className='btn btn-success' onClick={() => { this.setState({ showModal: false }) }}>OK</button></Modal.Footer>
                    </Modal.Header>
                </Modal>
                {/* Modal */}
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        delivery_time: state.delivery_time_reducer
    }
}

export default connect(mapStateToProps, { setPaymentStage })(OrderReviewFooter)


// WEBPACK FOOTER //
// ./src/components/component_order_review_footer.js